import template from './component.tpl.html';
import './controller';

angular
    .module('festzelt-os.dashboard')
    .component('dashboardOktoberfest', {
        bindings: {

        },
        controller: 'OktoberfestDashboardController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/components/oktoberfest-dashboard/component.js